import { useSetting } from '@tencent/setting-vue-webpack-plugin';
var timeSetting = useSetting('活动截止时间', {
  活动截止时间: {
    type: 'datetime',
    "default": '2030-08-28 23:59:59'
  },
  提示: '活动已经结束啦',
  按钮文案: '前往福利社',
  链接: 'https://film.qq.com/x/welfare/'
});
window.timeSetting = timeSetting;